import "../main.css";

export default function PalavraChaveFinanceira() {
  return (
    <div>
      <ul
        className="nav categories-nav nav-pills flex-column"
        role="navigation"
      >
        <li className="nav-item open">
          <h3>Palavras-chave</h3>

          <ul className="nav nav-pills flex-column">
            <li className="keypass-container">
              <a
                className=" keypass"
                href="/variaveis-financeiras#scorecredito"
              >
                Score de crédito
              </a>
              <a
                className="keypass"
                href="/variaveis-financeiras#riscofinanceiro"
              >
                Risco financeiro
              </a>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  );
}
